import React from 'react';
import { ChevronUp, ChevronDown, Minus } from 'lucide-react';
interface MovementIndicatorProps {
  currentRank: number;
  previousRank: number;
}
export function MovementIndicator({
  currentRank,
  previousRank
}: MovementIndicatorProps) {
  const diff = previousRank - currentRank;
  if (diff > 0) {
    return <div className="flex items-center text-emerald-400 text-sm font-medium" data-id="element-425">
        <ChevronUp className="w-4 h-4 mr-0.5" data-id="element-426" />
        <span data-id="element-427">{diff}</span>
      </div>;
  }
  if (diff < 0) {
    return <div className="flex items-center text-rose-400 text-sm font-medium" data-id="element-428">
        <ChevronDown className="w-4 h-4 mr-0.5" data-id="element-429" />
        <span data-id="element-430">{Math.abs(diff)}</span>
      </div>;
  }
  return <div className="flex items-center text-slate-500 text-sm font-medium" data-id="element-431">
      <Minus className="w-4 h-4 mr-0.5" data-id="element-432" />
      <span data-id="element-433">-</span>
    </div>;
}